import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import LinearProgress from 'material-ui/LinearProgress';
import SovosPaginationFooter from 's1-ui/sovos-pagination-footer';
import './connectionsGrid.scss';
import { gridHeaderColorGray, textColorGray } from 'theme/mainColors';
import ContextualGridMenuOptions from '../contextualGridMenuOptions/ContextualGridMenuOptions';


const headerLabelStyle = {
  color: gridHeaderColorGray,
  fontWeight: 400,
  fontSize: 15,
  paddingBottom: 0
};

const emptyGridLabelStyle = {
  color: textColorGray,
  fontWeight: 400,
  fontSize: '20px',
  textAlign: 'center',
  verticalAlign: 'middle',
  padding: '100px'
};

class ConnectionsGrid extends React.Component {
  constructor(props){
    super(props);
    this.connectionGridColumns = [
      {
        title: 'Label',
        dataKey: 'label',
        width: 270
      },{
        title: 'Description',
        dataKey: 'description'
      },{
        title: 'SFTP Address',
        dataKey: 'address',
        width: 150
      },{
        title: '',
        width: 40,
        dataKey: 'moreOptions',
        disabled: !props.showMoreActionsIcon
      }
    ];
    this.state = {
      hoveredRow: -1,
      itemsPerPage: 10,
      page: 0
    };
  }


  handleRowHover = hoveredRow => this.setState({ hoveredRow });

  handleCellClick = rowID => this.props.onConnectionSelect(this.props.connectionsListGridData[rowID]);

  getStartItem = () => (this.props.totalItems ? ((this.state.itemsPerPage * (this.state.page)) + 1) : 0);

  calculateEndItem = () => {
    const maximumItemsOnPage = this.state.itemsPerPage * (this.state.page + 1);
    if (maximumItemsOnPage > this.props.totalItems) {
      return this.props.totalItems;
    }
    return maximumItemsOnPage;
  };

  handlePrevPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if(oldState.page > 0 ) {
        this.props.onPageChange(oldState.page - 1, oldState.itemsPerPage);
        return ({
          page: oldState.page - 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handleNextPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if((oldState.page + 1) * oldState.itemsPerPage < this.props.totalItems) {
        this.props.onPageChange(oldState.page + 1, oldState.itemsPerPage);
        return ({
          page: oldState.page + 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handlePerPageChanged = ev => {
    const itemsPerPage = ev.target.value;
    this.setState({ page: 0, itemsPerPage });
    this.props.onPageChange(0, itemsPerPage);
  };

  handleEditConnection = connectionId => this.props.onEditConnection(connectionId);

  render() {
    const { connectionsListGridData, totalItems, fetchingConnections, showPagination, displayCheckbox, backgroundColor } = this.props;
    return (
      <div className="connections-grid__main-container">
        {
          fetchingConnections &&
          <div className="connections-grid__over-layer">
            <LinearProgress mode="indeterminate" />
          </div>
        }
        <div className={ `connections-grid__table-container${ fetchingConnections ? ' blur-content' : '' }` }>
          {
            connectionsListGridData.length > 0 &&
            <Table
              key="ConnectionsGrid"
              fixedHeader={ true }
              onRowHover={ this.handleRowHover }
              onRowHoverExit={ this.handleRowHoverExit }
              onCellClick={ this.handleCellClick }
              multiSelectable={ true }
              className="connections-grid"
              style={ { backgroundColor: backgroundColor } }
            >
              <TableHeader displaySelectAll={ false } enableSelectAll={ false } adjustForCheckbox={ displayCheckbox } style={ { border: 'none' } }>
                <TableRow style={ { border: 'none' } }>
                  { this.connectionGridColumns.map(({ dataKey, width, title, disabled }) => (
                    !disabled && <TableHeaderColumn key={ dataKey } style={ { width: width || 'auto', ...headerLabelStyle } }>
                      { title }
                    </TableHeaderColumn>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody showRowHover={ true } displayRowCheckbox={ displayCheckbox } deselectOnClickaway={ false }>
                { connectionsListGridData.map((connection, index) => (
                  <TableRow
                    id={ `import-connections-grid-row-${index}` }
                    key={ index }
                    hovered={ connection.disabled }
                    hoverable={ !connection.disabled }
                    selectable={ !connection.disabled }
                    selected={ connection.selected }
                    className={ `connections-grid__table-row${ connection.disabled ? ' connections-grid__table-row_not-selectable' : ''}` }
                  >
                    { this.connectionGridColumns.map(({dataKey, width, disabled}) => (
                      !disabled && <TableRowColumn key={ dataKey } style={ {width: width || 'auto', textOverflow: `${dataKey !== 'moreOptions' ? 'ellipsis' : 'unset'}`} }>{
                        (dataKey !== 'moreOptions') ?
                          connection[dataKey] :
                          this.state.hoveredRow === index  && <ContextualGridMenuOptions elementId={ connection.id } onEdit={ this.handleEditOrganization } deleteDisabled={ true } />
                      }</TableRowColumn>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          }
          {
            connectionsListGridData.length > 0 && showPagination &&
            <SovosPaginationFooter
              key="ConnectionsPaginationFooter"
              endItem={ this.calculateEndItem() }
              itemsPerPage={ this.state.itemsPerPage }
              startItem={ this.getStartItem() }
              totalItems={ totalItems }
              onPrevClicked={ this.handlePrevPage }
              onNextClicked={ this.handleNextPage }
              onPerPageChanged={ this.handlePerPageChanged }
              itemsPerPageOptions={ [ 10, 25, 50 ] }
            />
          }
        </div>
        {
          connectionsListGridData.length <= 0 && !fetchingConnections &&
          <div style={ emptyGridLabelStyle }>
            No Connections Created
          </div>
        }
      </div>
    );
  }
}

ConnectionsGrid.propTypes = {
  totalItems: PropTypes.number,
  onRowRemove: PropTypes.func,
  connectionsListGridData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onConnectionSelect: PropTypes.func,
  onPageChange: PropTypes.func,
  fetchingConnections: PropTypes.bool,
  showPagination: PropTypes.bool,
  displayCheckbox: PropTypes.bool,
  showMoreActionsIcon: PropTypes.bool,
  onEditConnection: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string
};

ConnectionsGrid.defaultProps = {
  fetchingConnections: false,
  onConnectionSelect: () => null,
  totalItems: 0,
  onPageChange: () => null,
  showPagination: false,
  displayCheckbox: false,
  onRowRemove: () => null,
  showMoreActionsIcon: false,
  backgroundColor: '#fff'
};

export default ConnectionsGrid;



// WEBPACK FOOTER //
// ./src/shared/connectionsGrid/ConnectionsGrid.js